import * as Sentry from "@sentry/react";

/**
 * Sentry initialization for error tracking and performance monitoring.
 *
 * Configuration is loaded from environment variables:
 * - VITE_SENTRY_DSN: Sentry project DSN
 * - VITE_ENVIRONMENT: Environment name (development/production)
 * - VITE_SENTRY_TRACES_SAMPLE_RATE: Trace sampling rate (0.0-1.0)
 * - VITE_ALLOWED_ORIGIN_DOMAIN: Domain pattern for trace propagation
 */

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_ENVIRONMENT || "development";
const tracesSampleRate = parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "1.0");
const allowedOriginDomain = import.meta.env.VITE_ALLOWED_ORIGIN_DOMAIN || ".datasurfr.ai";

// Only initialize Sentry if DSN is configured
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: environment,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Distributed tracing - captures frontend-to-backend traces
    integrations: [Sentry.browserTracingIntegration()],

    // Trace sample rate from environment (default: 1.0 for dev, 0.1 for prod)
    tracesSampleRate: tracesSampleRate,

    // Propagate traces to these backends (enables end-to-end tracing)
    tracePropagationTargets: [
      "localhost",
      new RegExp(`^https://.*${allowedOriginDomain.replace(".", "\\.")}$`),
    ],
  });
} else {
  console.warn("Sentry DSN not configured - error tracking disabled");
}
